import {Entity} from '@s-ui/domain'

export class ProfessionalActivityTransactionsEntity extends Entity {
  /**
   * @constructor
   * @param {String} id
   * @param {String} description
   */
  constructor({description, id}) {
    super()
    this._description = description
    this._id = id
  }

  static create({description, id}) {
    return new ProfessionalActivityTransactionsEntity({description, id})
  }

  getDescription() {
    return this._description
  }

  getId() {
    return this._id
  }

  toJSON() {
    return {
      description: this._description,
      id: this._id
    }
  }
}
